var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicIosCheckboxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-checkbox-outline",
    "data-name": "Icon ionic-ios-checkbox-outline",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24397",
    "data-name": "Path 24397",
    d: "M16.25,2.5H3.75A1.249,1.249,0,0,0,2.5,3.75v12.5A1.249,1.249,0,0,0,3.75,17.5h12.5a1.249,1.249,0,0,0,1.25-1.25V3.75A1.249,1.249,0,0,0,16.25,2.5Zm.156,13.594a.313.313,0,0,1-.312.313H3.906a.313.313,0,0,1-.312-.312V3.906a.313.313,0,0,1,.313-.312H16.094a.313.313,0,0,1,.313.313Z",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24398",
    "data-name": "Path 24398",
    d: "M14.2,7.535l-.687-.707a.148.148,0,0,0-.109-.047h0a.142.142,0,0,0-.109.047l-4.766,4.8L6.8,9.895a.151.151,0,0,0-.219,0l-.7.7a.156.156,0,0,0,0,.223L8.07,13a.692.692,0,0,0,.457.223.725.725,0,0,0,.453-.215h0l5.223-5.25A.167.167,0,0,0,14.2,7.535Z",
    fill: "#dfdfdf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicIosCheckboxOutline);
export default __webpack_public_path__ + "static/media/ionic-ios-checkbox-outline.6526bfc0c8f7da354fbb118f7e816537.svg";
export { ForwardRef as ReactComponent };